import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{
  isSidePanelOpened: boolean
  isExternal: boolean
  paddingZero?: boolean
  bgColor?: string
}>()(
  (theme, { isExternal, isSidePanelOpened, bgColor, paddingZero }) => ({
    root: {
      backgroundColor: theme.palette.textBackground.light,
      ...(isExternal
        ? { marginLeft: theme.spacing(0) }
        : {
            marginLeft: isSidePanelOpened
              ? theme.spacing(35)
              : theme.spacing(9),
          }),
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
      height: '100vh',
      backgroundColor: bgColor ? bgColor : theme.palette.textBackground.light,
    },
    appBody: {
      width: '100%',
      padding: paddingZero
        ? theme.spacing(0)
        : isExternal
          ? theme.spacing(2.5, 2.5, 0, 2.5)
          : theme.spacing(4, 4, 0, 4),
      boxSizing: 'border-box',
    },
  })
)
